import { useColumnVisibilityStore } from '@/store/column-visibility-store'

const NO_HIDDEN_COLUMNS: string[] = []

/** Visibilidade das colunas de uma tabela, persistida na store (zustand). */
export function useColumnVisibility(tableId: string, allKeys: string[]) {
	const hiddenKeys = useColumnVisibilityStore(
		(state) => state.hiddenColumns[tableId] ?? NO_HIDDEN_COLUMNS,
	)
	const toggleColumn = useColumnVisibilityStore((state) => state.toggleColumn)
	const resetColumns = useColumnVisibilityStore((state) => state.resetColumns)

	return {
		isVisible: (key: string) => !hiddenKeys.includes(key),
		toggle: (key: string) => toggleColumn(tableId, key, allKeys),
		reset: () => resetColumns(tableId),
		hasHidden: hiddenKeys.length > 0,
	}
}
